export default __webpack_public_path__ + "static/pursuit-2d1b82a545d2e19b58bda8a7828f6875.gif";